// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"f32a73c2","351":"73277598","453":"d668ec96","471":"821f59f5","583":"8591660e","629":"568a99bc","745":"62c16dff","879":"984c4cde","948":"3443db00"}[chunkId] + ".chunk.js";
};